import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Toolbar,
} from "@mui/material";
import { Sidebar } from "../../../../components/";

import DisruptionSuccessPrompt from "./DisruptionSuccessPrompt";
import { TypographyXLarge } from "../../../../components/customComponent";
import DelayActivation from "./delayDisruption/DelayActivation";
import DisruptionActivation from "./delayDisruption/DisruptionActivation";
import InteractableMap from "./InteractableMap";
import { useDispatch } from "react-redux";
import { getSMPDisruption } from "../../../store/actions/bplrt/smpAction";
import DisruptionErrorPrompt from "./DisruptionErrorPrompt";
import ActiveAnnouncementCard from "../../../../components/home/ActiveAnnouncementCard";

import { useNavigate } from "react-router-dom";
import TickertapeButton from "./TickertapeButton";
import { useTranslation } from "react-i18next";
import NewSmpButton from "./newSmp/NewSmpButton";

const SMP = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation("bplrtSmp");
  const { t: tEquip } = useTranslation("bplrtEquipment");
  useEffect(() => {
    dispatch(getSMPDisruption());
  }, [dispatch]);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 2 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
          </Box>

          <DisruptionErrorPrompt />
          <DisruptionSuccessPrompt />
          <InteractableMap />
          <Grid container sx={{ mb: "20px" }}>
            <Grid item sx={{ mr: "8px" }}>
              <TickertapeButton />
            </Grid>
            <Grid item sx={{ mr: "8px" }}>
              <Button
                variant="contained"
                onClick={() => {
                  navigate("/bplrt/equipment");
                }}
                fullWidth
                sx={{ boxShadow: 3 }}
              >
                {tEquip("navigateBtn")}
              </Button>
            </Grid>

            <Grid item sx={{ mr: "8px" }}>
              <DelayActivation />
            </Grid>

            <Grid item sx={{ mr: "8px" }}>
              <DisruptionActivation />
            </Grid>
            <Grid item sx={{ mr: "8px" }}>
              <NewSmpButton />
            </Grid>
          </Grid>

          <ActiveAnnouncementCard />
        </Container>
      </Box>
    </Box>
  );
};

export default SMP;
